
import AjaxPlugin from 'vux/src/plugins/ajax/index.js'
import Cell from 'vux/src/components/cell/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Previewer from 'vux/src/components/previewer/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import XButton from 'vux/src/components/x-button/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'


export default {
components: {
Selector,
Confirm,
XTextarea,
Group,
Tab,
Cell,
TabItem,
XButton,
XInput,
Previewer
},
directives: {
TransferDom
},
data() {
return {
clean_reason: '',
clean_detail: '',
reason: [{key: 'REJECT', value: '拒绝'}, {key: 'REGRET', value: '反悔'}, {
key: 'UNQUAL',
value: '不合格'
}, {key: 'TIMEOUT', value: '超时'}, {key: 'UCANCLR', value: '用户取消'}],
clearotherdesignateshow: false,
roleType:'',
options: {
getThumbBoundsFn(index) {

let thumbnail = document.querySelectorAll('.previewer-demo-img')[index]

let pageYScroll = window.pageYOffset || document.documentElement.scrollTop


let rect = thumbnail.getBoundingClientRect()

return {x: rect.left, y: rect.top + pageYScroll, w: rect.width}


}
},
list: ['详情信息', '报修记录'],
index: 0,
orderDetail: {},
showLoading: false,
isShow: false,
imgList: [],
filename:'',
filepath:'',

iden: '',
solutionv: 1,
isFault: false,
istoggle: false,
iswait: true,
show: false,
flag: true,
class_a: 'active',
task: true,
confirmFault: '修改故障',
isTwo: true
}
},
methods: {
desiginate() {
this.$router.push({name: 'Desiginate', query: {role: 'EXPT', seq: this.orderDetail.seq}})
},


downloadFile(){
this.$router.push({
name: "Download",
query: {path:this.filepath, suffix:this.filename}
});
},

cleardesiginate() {
let header = {
headers: {
token: localStorage.getItem('token'),
opid: localStorage.getItem('userid')
}
}
this.$http.post('/api/v1/normalrepairs/' + this.orderDetail.seq + '/clear_assign_to_assist', {
"reason": this.clean_reason,
"detail": this.clean_detail,
role: 'EXPT'
}, header).then(() => {
alert('清除成功');
this.$router.push({name: 'engineer'})
})
},
more() {
this.show = !this.show
},
showx(index) {
this.$refs.previewer.show(index)
},
success() {
this.$router.push({name: 'finish', params: {obj: this.orderDetail, role: 'EXPT'}})
},
Confirmfault() {
this.$router.push({name: 'confirmfault', params: {obj: this.orderDetail}})
},
detail() {
this.$router.push({name: 'detaillist'})
},
assistantinfo() {
this.$router.push({name: 'assistantinfo', query: {seq: this.orderDetail.seq,role:'EXPT'}})
},
bxjl() {
if (this.isShow) {
this.$vux.toast.show({
text: '无权限查看报修进度信息，请先接受订单',
type: 'cancel',
time: '1000'
})
} else {
this.$router.push({name: 'makeMemo', params: {iden: this.iden, solutionv: this.solutionv}})
}
},
agree() {
this.showLoading = true
var obj = {
role: this.iden,
op: 'ACCEPT',
comment: ''
}
var header = {
headers: {
token: localStorage.getItem('token'),
opid: localStorage.getItem('userid')
}
}
var that = this
this.$http.post('/api/v1/normalrepairs/' + this.orderDetail.seq + '/order', obj, header)
.then(function (res) {
console.log(res)
that.$router.push({name: 'engineer'})
})
.catch(function (error) {
that.$vux.toast.show({
text: JSON.parse(error.response.data.error_message).zh_string,
type: 'cancel',
time: '1000'
})
this.showLoading = false

})
},
reject() {
this.$router.push({name: "cancel", params: {name: 'reject'}})
},
cancel() {
this.$router.push({name: "cancel", params: {name: 'cancel'}})
}
},
beforeRouteEnter(to, from, next) {
next(vm => {
const openid = localStorage.getItem('openid')
const unionid = localStorage.getItem('unionid')
let account
AjaxPlugin.$http.get('api/v1/wechat/' + unionid).then((res) => {



res.data.forEach(item => {
if (item.role === 'EXPT') {
account = item.account
}
})
AjaxPlugin.$http.post('api/v1/wechat/' + unionid + '/token', {'account': account}).then(response => {
localStorage.setItem('token', response.data.token)
localStorage.setItem('userid', response.data.userid)
const userid = response.data.userid
let header = {
headers: {
token: response.data.token,
opid: response.data.userid
}
}
AjaxPlugin.$http.get('/api/v1/normalrepairs/' + to.query.seq + '?role=EXPT&type=detail', header).then(response => {
localStorage.setItem('order', JSON.stringify(response.data.detail))
vm.orderDetail = response.data.detail
if (vm.orderDetail.state === 'WAIT') {
vm.isShow = !vm.orderDetail.canstate
}
if (vm.orderDetail.confirm === 'WAIT') {
vm.iswait = false
vm.flag = false
vm.task = false
vm.confirmFault = '确认故障'
}
if (vm.orderDetail.state === "PROCESS") {
vm.isFault = true
}
if(vm.orderDetail.expert){
if (userid === vm.orderDetail.expert.userid) {
vm.roleType = 'self'
if (vm.orderDetail.exptstate === 'WAIT') {
vm.isShow = true
vm.isFault = false
}
}
}
if (vm.orderDetail.assit){
if (userid === vm.orderDetail.assit.userid) {
vm.roleType = 'other'
if (vm.orderDetail.assitstate === 'WAIT') {
vm.isShow = true
vm.isFault = false
}
}
}
switch (vm.orderDetail.assitstate) {
case 'WAIT':
vm.orderDetail.assitstate = '待接受';
break;
case 'ACCEPT':
vm.orderDetail.assitstate = '接受';
break;
case 'REJECT':
vm.orderDetail.assitstate = '拒绝';
break;
default:
vm.orderDetail.assitstate = '反悔';
break;
}
switch (vm.orderDetail.userconfirm) {
case 'ACCEPT':
vm.orderDetail.userconfirm = '接受'
break;
case 'REJECT':
vm.orderDetail.userconfirm = '拒绝'
break;
default:
vm.orderDetail.userconfirm = ''
break;
}
vm.solutionv = vm.orderDetail.solutionv
vm.iden = 'EXPT'
vm.imgList = [];



if (vm.orderDetail.signature && vm.orderDetail.signature.content.length !== 0) {
if(vm.orderDetail.signature.content[0].describe==""){
vm.orderDetail.signature.content[0].path.forEach(item => {
let path = vm.orderDetail.signature.version === '1.0' ? item : item['origin']
AjaxPlugin.$http.get('/api/photos?path=' + path, header).then(paths => {
vm.imgList.push({src: 'data:image/jpeg;base64,' + paths.data['value']});
});
});
}else{

vm.filename = vm.orderDetail.signature.content[0].describe
vm.filepath = vm.orderDetail.signature.content[0].path[0].origin
}

}
})
})
})
})
}
}



// WEBPACK FOOTER //
// ./src/components/records.vue